import React from 'react'
import { YStack } from 'tamagui'

export const YouTubeEmbed = ({
  youtubeEmbedUrl,
}: {
  youtubeEmbedUrl: string
}) => (
  <YStack width="100%" maxWidth="100%">
    <iframe
      src={youtubeEmbedUrl}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title="Embedded youtube"
      style={{
        width: '100%',
        aspectRatio: '16 / 9',
        display: 'block',
      }}
    />
  </YStack>
)
